<template>
  <div v-if="data">
    <!-- <div class="flex text-left mt-2 font-semibold">{{ data.name }}</div> -->
    <div class="base addborder py-4" v-for="(product, index) in data.products.items" :key="index">
      <div class="flex space-x-4 pl-2 p-1">
        <img :src="$firstImage(product.images, 'small')" alt="" class="img my-4px w-32 h-32 object-cover"
          :onerror="defaultUrl" />
        <div class="text-left">
          <p class="font-bold space-x-2 mt-1">
            <span>{{ product.name }}</span>
          </p>
          <p class="text-gray-400"></p>
        </div>
      </div>
      <div class="border flex-center">{{ product.attribute_text }}</div>
      <div class="flex-center">
        <span class="count">
          {{ product.quantity }}
        </span>
      </div>
      <div class="flex-center">{{ $p(product.price) }}</div>
      <div class="flex-center">0</div>
      <div class="flex-center">{{ $p(product.subtotal) }}</div>
    </div>

  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";
import { ref, computed, watchEffect } from "@vue/composition-api";

export default defineComponent({
  props: { data: Object, quantity: Number },
  setup(props, ctx) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    const num = ref(0);
    watchEffect(() => {
      // num.value = props.quantity;
    });
    const handleChange = (val) => {
      // ctx.emit("now-count", val);
    };
    const total = computed(() => num.value * props.data.price);
    return { handleChange, total, num, defaultUrl };
  },
});
</script>

<style scoped lang="scss">.title {
  text-align: start;
}
.title >h1 {
  font-size: 1.125rem;
  margin-bottom: 1rem;
  font-weight: bold;
}
.title >p {
  margin-bottom: 0.5rem;
}
.base {
  display: grid;
  grid-template-columns: 3fr 2fr 2fr repeat(3, 1fr);
}
.title2 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
  border-width: 1px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.bd {
  border-width: 1px;
  border-top-width: 0px;
}
.bd>p, .bd .params {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-left-width: 1px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.addborder >div {
  border-width: 1px;
  margin-left: -1px;
}</style>
